import Vue from 'vue'

import 'normalize.css/normalize.css'// A modern alternative to CSS resets

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n
import VCharts from 'v-charts'

import '@/styles/index.scss' // global css

import App from './App'
import router from './router'
import store from './store'

import '@/icons' // icon
import '@/permission' // permission control

Vue.use(ElementUI, { locale })
Vue.use(VCharts)

Vue.config.productionTip = false

// 全局混入：标签栏切换页面时，被 keep-alive 缓存的页面重新拉取数据
// 1. 仅对缓存中的页面组件生效（组件 name 即路由 name，与 cachedViews 一致）
// 2. 首次进入不重复请求（created 已请求），仅“切走后再切回”时刷新
// 3. 页面可自定义 refreshData() 覆盖默认的取数方法
const REFRESH_METHODS = ['refreshData', 'getList', 'getData', 'loadData', 'getListData', 'fetchData']
Vue.mixin({
  deactivated() {
    const cachedViews = this.$store && this.$store.state.tagsView.cachedViews
    const name = this.$options.name
    if (cachedViews && name && cachedViews.includes(name)) {
      this._needRefreshOnActivate = true
    }
  },
  activated() {
    if (!this._needRefreshOnActivate) return
    this._needRefreshOnActivate = false
    // 保留缓存状态（筛选条件、分页），仅重新请求列表数据
    const method = REFRESH_METHODS.find(fn => typeof this[fn] === 'function')
    if (method) this[method]()
  }
})

new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js